import {
  DOMAIN,
  Header,
  ContentType,
  GetFormData,
  Method,
  http
} from './api-utils';

/**
 * 商品数量列表
 */
export const goodsNumberList = async () => {
  const { data } = await http({
    method: Method.GET,
    url: DOMAIN + '/merchant/num/scope/list'
  });

  const list = data.msg;

  return {
    list
  };
};

/**
 * 平均客单价列表
 */
// export const predictAveragePriceList = async () => {
//   const { data } = await http({
//     method: Method.GET,
//     url: DOMAIN + '/merchant/num/scope/list'
//   });

//   const list = data.msg;

//   return {
//     list
//   };
// };

/**
 * 仓库列表
 */
export const stockList = async () => {
  const { data } = await http({
    method: Method.GET,
    url: DOMAIN + '/merchant/warehouse/list'
  });

  const list = data.msg;

  return {
    list
  };
};

/**
 * erp类型列表
 */
export const erpTypeList = async () => {
  const { data } = await http({
    method: Method.GET,
    url: DOMAIN + '/merchant/erp/list'
  });

  const list = data.msg;

  return { list };
};

/**
 * 接受邀请列表
 */
export const receivedInviteList = async () => {
  const { data } = await http({
    method: Method.GET,
    url: DOMAIN + '/merchant/vertical/stands/list'
  });

  const list = data.msg;

  return { list };
};

/**
 * 店铺类型列表
 */
export const shopTypeList = async () => {
  const { data } = await http({
    method: Method.GET,
    url: DOMAIN + '/merchant/shop/type/list'
  });

  const list = data.msg;

  return { list };
};

/**
 * 获取招商入驻状态信息
 */
export const merchantAuditStatus = async () => {
  const { data } = await http({
    method: Method.GET,
    url: DOMAIN + '/merchant/investment/status/query'
  });

  const {
    expectShopName: shopName,
    shopLoginName: shopUsername,
    status
  } = data;

  return {
    info: {
      shopName,
      shopUsername,
      status
    }
  };
};

/**
 * 申请招商入驻
 * @param {*} param0
 */
export const addMerchant = async ({
  name,
  telPhone,
  email,
  gender,
  companyName,
  legalPersonName,
  idCard,
  legalPersonIdPicFileList,
  companyLocationProvince,
  companyLocationCity,
  companyLocationRegion,
  companyDetailLocation,
  establishTime,
  businessEndTime,
  businessStartTime,
  registeredCapital,
  businessScope,
  businessLicensePicListFile,
  companyPhone,
  companyEmergencyContact,
  companyEmergencyContactPhone,
  organizationCode,
  companyWebsiteAddress,
  salesIneLatestYear,
  similarElectronicWebsiteExperience,
  shopAddress,
  onlineShopOperatorsNumber,
  goodsNumberForSaleOnline,
  averageUnitPrice,
  warehouse,
  warehouseAddress,
  commonLogisticsCompany,
  erpType,
  agentOperatingCompanyName,
  traderSandStorage,
  liquorMallLogistics,
  openDistributionQualification,
  verticalStanding,
  expectedShopType,
  mainCategory,
  detailCategoryIds,
  hasCategoryIndustryQualification,
  categoryIndustryQualification,
  categoryDescribeKeyword,
  expectShopName,
  shopLoginName,
  shopLoginPassword,
  shopSuffix
}) => {
  const param = {
    name,
    telPhone,
    email,
    gender,
    companyName,
    legalPersonName,
    idCard,
    legalPersonIdPicFileList:[...legalPersonIdPicFileList],
    companyLocationProvince,
    companyLocationCity,
    companyLocationRegion,
    companyDetailLocation,
    establishTime,
    businessEndTime,
    businessStartTime,
    registeredCapital,
    businessScope,
    businessLicensePicListFile,
    companyPhone,
    companyEmergencyContact,
    companyEmergencyContactPhone,
    organizationCode,
    companyWebsiteAddress,
    salesIneLatestYear,
    similarElectronicWebsiteExperience,
    shopAddress,
    onlineShopOperatorsNumber,
    goodsNumberForSaleOnline,
    averageUnitPrice,
    warehouse,
    warehouseAddress,
    commonLogisticsCompany,
    erpType,
    agentOperatingCompanyName,
    traderSandStorage,
    liquorMallLogistics,
    openDistributionQualification,
    verticalStanding,
    expectedShopType,
    mainCategory,
    detailCategoryIds,
    hasCategoryIndustryQualification,
    categoryIndustryQualification,
    categoryDescribeKeyword,
    expectShopName,
    shopLoginName,
    shopLoginPassword,
    shopSuffix
  };
  const formData = GetFormData(param);

  await http({
    method: Method.POST,
    url: DOMAIN + '/merchant/investment/in',
    headers: {
      [Headers.ContentType]: ContentType.FormData
    },
    data: formData
  });
};
